module.exports = __webpack_public_path__ + "static/media/sigma.b135dbe0.svg";